import { ComboBox, DefaultButton, DirectionalHint, IComboBoxOption, IDropdownOption, Label, TextField , TooltipHost} from "@fluentui/react";
import { FormEvent, useEffect, useMemo, useRef, useState } from "react";
import { convertHourToMin, convertMinToHour, FileUpload, formatDate, Iactivities, IconPapers, Ifileselect, IListFile, LoadingPage } from "./FileUpload";
import { uploadItemActivityType, uploadTypeActivity } from "../../system/documents/DocumentsUploader";
import { v4 as uuidv4 } from 'uuid';
import { DateCustom } from "../../lib/DateCustom";
import { useTranslation } from "react-i18next";
import { FormUploadHeader } from "./ImportAct";
import Custoneader from "./Custoneader";
import { AddIcon, IactError, IAddRows, ICollaborator, IComboBoxInput, ICompanyPanel, UploadIcon } from "./InterfaceFormulario";
import { IActivityRecurring, IAddRecurrentActivity, IPlantillaActividadesXColaborador, IPosplantillaActividadesColaborador, ItipoConcepto } from "../../system/projects/ProjectsSystem";
import { Callout } from "@fluentui/react";
import useIsMobile from "../../common/custom-hooks/useIsMobile";
import Loading from "../Spinners/Loading";
import ActivityRow from "./ActivityRow";
import { formatDateTimeYYMMDDDDHHMM, normalizeText } from "../../lib/Util";
import HoursLimitDialog from "./HoursLimitDialog";
import XhrRequestError from "../../lib/XhrRequestError";
import { DateTime } from "luxon";
import DialogRecoveredData from "../../lib/GlideDataGrid/DialogRecoveredData";
import { Calendar, getDefaultFilters } from "../../classes/Calendar/Calendar";
import { EventOutlook } from "../../system/activity/EventsOutlook";
import { CalendarFilters } from "../Calendar/CalendarProjectView";
import { isNull } from "lodash";


const IMPORTED_ROW_PREFIX = "Actividad Importada para el día";
const IMPORTED_ROW_REGEX = new RegExp(`^${IMPORTED_ROW_PREFIX} [^.]*\\.`);
const SESSION_STORAGE_KEY_FORMULARIO = 'dataFormulario';

const isValidHoursMinutes = (value: any) => {
  if (value === null || value === undefined) return false;
  const number = Number(value);
  return Number.isInteger(number) && number >= 0;
};

const saveOnSessionStorageDataFormulario = (data: IAddRows[]) => {
  console.log("val-saveOnSessionStorageDataFormulario", data);

  sessionStorage.setItem(SESSION_STORAGE_KEY_FORMULARIO, JSON.stringify(data));
};

const getSessionStorageDataFormulario = (): IAddRows[] => {
  const stored = sessionStorage.getItem(SESSION_STORAGE_KEY_FORMULARIO);
  console.log("val-getSessionStorageDataFormulario", stored);
  if (!stored) return [];
  try {
    return JSON.parse(stored);
  } catch (e) {
    console.warn("Error al parsear dataFormulario desde sessionStorage:", e);
    return [];
  }
};

export interface IactivitiesBody {
  activities:Iactivities[];
  col_id: string;
  exercise_period: string;
  timezone: string;
}

export interface IactivitiesResponse {
  data:Iactivities[];
  error:string;
  type:string;
}

function CargarPorFormulario(props: ICompanyPanel) {
  const headers = { idTransaccion:uuidv4(), msgTransaccion:"horas Total Collaborator" }
  const { t, i18n } = useTranslation();
    const [addRows,setAddRows] = useState<IAddRows[]>([]);
    const [actError, setActError] = useState<IactError>({actVali:0,actvErro:0});
    const [desabled, setDesabled] = useState<boolean>(true);

    const [showHoursDialog, setShowHoursDialog] = useState(false);
    const [showRecoveredDataDialog, setShowRecoveredDataDialog] = useState(false);

    const [allCollaborators, setAllCollaborators] = useState<IComboBoxOption[]>([]);
    const [filteredCollaborators, setFilteredCollaborators] = useState<IComboBoxOption[]>([]);
    const [collaboratorValue, setCollaboratorValue] = useState<string>('');
    const [collaboratorId, setCollaboratorId] = useState<string>('');
    const [listFile, setListFile] = useState<IListFile[]>([]);

    const [periodo,setPeriod] = useState<Date>(DateCustom.getFirstDayOfThisMonth())
    const [horasExcedidas, setHorasExcedidas] = useState<number>(0);
    const [desableAddRow, setDesableAddRow] = useState<boolean>(false);

    const [mountBlock, setMountBlock] = useState<{[key: number]: number[]}>({});
    const [horasTotalCollaborator,setHorasTotalCollaborator] = useState<number>(0);
    const actividadRecurrentenbasic:IActivityRecurring  = {
      ar_id:"",ar_nombre_descripcion:"",ar_proy_id:"",key:"",
      text:"",ar_activo:1,ar_date_created:new Date(),ar_date_modified:new Date(),ar_eliminado:0,
      ar_nombre_act:"",ar_user_created:"web",ar_user_modified:"web", ar_pais_id: 1, ar_empresa_id:1
    };
    const [listCompanies, setListCompanies] = useState<IComboBoxOption[]>([]);
    const [filterListCompanies, setFilterListCompanies] = useState<IComboBoxOption[]>([]);
    const [listProjects, setListProjects] = useState<IComboBoxInput[]>([]);
    const [listServices, setListServices] = useState<IComboBoxInput[]>([]);
    const [listAllProjects, setListAllProjects] = useState<IComboBoxInput[]>([]);
    const [listtipoConcept,setListtipoConcept] = useState<ItipoConcepto[]>([]);
    const [filterTipoConsept, setFilterTipoConsept] = useState<ItipoConcepto[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { isMobile } = useIsMobile();
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [showCallout, setShowCallout] = useState(false);
    const iconRef = useRef(null);
    const [isLoadingEventsFromOutlook, setIsLoadingEventsFromOutlook] = useState(false)

    const aiActivityEnhancementSystem= props.system.getAiActivityEnhancementSystem()

    const horasTotal = useMemo(() => {
      const totalMinutosCargados = addRows.reduce((acc, row) => {
        const [h, m] = (row.horasCarg || "").split(":");
        if (isValidHoursMinutes(h) && isValidHoursMinutes(m)) {
          return acc + convertHourToMin(row.horasCarg);
        }
        return acc;
      }, 0);
      return horasTotalCollaborator - totalMinutosCargados;
    }, [addRows, horasTotalCollaborator]);

    useEffect(() => {
      // Calcular el total de horas que se intenta registrar en el mes
      const totalHorasCargadas = addRows.reduce((acc, row) => acc + convertHourToMin(row.horasCarg), 0);

      // Validar si excede el límite de horas
      if (totalHorasCargadas > horasTotalCollaborator) {
        props.courier.messageWarning(
          `Has superado las horas establecidas para este mes.
          Puedes modificar las horas antes de registrar tus actividades.
          [Recuerda que solo se permite un máximo de 3 horas extras por día, ${horasExcedidas.toString().split(":")[0]} horas extras al mes.]`
        );
      } else {
        if (addRows.length > 0 && totalHorasCargadas > 0) {
          props.courier.messageWarning('')
        }
      }
    }, [addRows, horasTotalCollaborator])
    const updateActivityNameAndDescription = (
      id: string,
      newNombreAct: string,
      newDescripcion: string
    ) => {
      setAddRows(prev => {
        const updatedRows = prev.map((row) => {
          if (row.id === id) {
            return {
              ...row,
              nombreAct: newNombreAct,
              descripcion: newDescripcion,
            };
          }
          return row;
        });
        // Validar la fila actualizada en tiempo real
        validateRowById(updatedRows, id);
        return updatedRows;
      });
    };

    const getAllPeriodBlocks = async () => {
      const periodBlocks = await props.system.getAllPeriodsBlocked();
      const newMountBlocks = periodBlocks
          .map(data => ({ year: data.getFrom().year, month: data.getFrom().month }))
          .reduce((acc, { year, month }) => {
              if (!acc[year]) acc[year] = [];
              acc[year].push(month);
              return acc;
          }, {} as { [key: number]: number[] });
      setMountBlock(newMountBlocks);
  };

    const handleSelectCollaborator =async (option: IComboBoxOption | undefined) => {
      props.changeBlockUI(true);
      cleanActiveProject();
      setCollaboratorValue(option?.text || "");
      if (option?.key !== undefined) {
        const data = String(option.key);
        setCollaboratorId(data);
        const exercise_period = formatDate(periodo);
        await  getHorasTal(data,exercise_period);
      }
      props.changeBlockUI(false);
    };

    const handleFilterCollaborator = (text: string) => {
      setCollaboratorValue(text);
      const data = allCollaborators.filter(g => g.text.toLowerCase().includes(text.toLowerCase()));
      setFilteredCollaborators(data);
    };

    const formatCollaboratorData = (data: ICollaborator[]) => {
      const result: IComboBoxOption[] = data.map(col => ({
        key: col.id,
        text: `${col.name} ${col.lastName}`,
        active: col.active,
        email: col.email
      }));
      if (!result) return;
      setAllCollaborators(result);
      setFilteredCollaborators(result);
    };

    const fetchCollaborators = async () => {
      try {
        const data = await props.system.getActivitySystem().getCommonContext();
        formatCollaboratorData(data.colaboradores as ICollaborator[]);
      } catch (error) {
        console.error('Error fetching collaborators:', error);
      }
    };

    const fetchProjects = async (userData:string,periodo:string,tipoConcept:string | number |undefined) => {
      try {
        const data = await props.system.getAllProjectsByCollaboratorCargarFormulario(userData,periodo,tipoConcept);
        const transformsci =  data.map(v=>({ key:v.getId(),text:v.getName(), code:v.getCode(), pro_inicio:  v.getStart(), pro_fin: v.getEnd() }));
        return transformsci
      } catch (error) {
        console.error('Error fetching projects:', error);
      }
    };

    const getLisTipoConcept = async ()=>{
       try{
        const data = await props.system.getProjectSystem().gettipoConsepto(headers.idTransaccion);
        setListtipoConcept(data);
        setFilterTipoConsept(data);
       }catch(error){
        console.log('error fetching tipo concept', error);
       }
    };

    const getListWorkingDay = async (company: string, year: string) => {
      const data = await props.system.getNonWorkingDaysSystem().getListWorkingDaysHolidays(company, year);
      const mesNumber = DateTime.fromJSDate(periodo).month;
      const dataMes = data[0]?.data.find((d) => d.item === mesNumber);
      if (dataMes) {
        setHorasExcedidas(dataMes.diasLaborales * 3);
      }
    };

    const getCompaniesAndProjects = async (period: Date) => {
      try {
        const periodFormat = period.toISOString().split('T')[0];
        const data = await props.system.getCompanySystem().getListComapniesActives(periodFormat);
        const options: IComboBoxOption[] = data.map((company) => ({
          key: company.getId(),
          text: company.getName(),
        }));
        setListCompanies(options);
        setFilterListCompanies(options);

        const exercise_period = formatDate(periodo);
        const dataProjects = await fetchProjects(collaboratorId, exercise_period, 1);
        const dataProjectsServices = await fetchProjects(collaboratorId, exercise_period, 2);
        const allProjects = [
          ...(dataProjects ?? []),
          ...(dataProjectsServices ?? [])
        ];
        setListProjects(dataProjects || []);
        setListServices(dataProjectsServices || []);
        setListAllProjects(allProjects || []);
      } catch (error) {
        console.log('error fetching list empresas y proyectos', error);
      }
    }

    const validateRow = (row: IAddRows, id?: string) => {
      let descripcionError = "";
      const nombreActValido = /^[^\s]/.test(row.nombreAct) && !/\s{2,}/.test(row.nombreAct);
      const regex = /^(?:\d{1,3}:)?(\d{1,2}|undefined)?$/;
      const segundoRegex = /^:\d{1,2}$/;
      const valorMin = convertHourToMin(row.horasCarg);
      const regexUndefine = /:undefined|undefined/;
      const [horaParte, minutoParte] = (row.horasCarg || "").split(":");
      const importedPrefix = row.descripcionError?.match(IMPORTED_ROW_REGEX)?.[0];

      if (
        !row.comapaniesSelect?.length &&
        !row.tipoConcepto?.text &&
        !row.nombrePro?.text &&
        !row.nombreAct &&
        (row.horasCarg === "00:00" || !row.horasCarg)
      ) {
        if (importedPrefix) {
          return {
            ...row,
            descripcionError: `${importedPrefix} Faltan campos obligatorio`,
            valida: 2,
          };
        }
        return { ...row, descripcionError: "nueva fila", valida: 2 };
      } else {
        if (
          (!row.nombreAct && !row.horasCarg) ||
          (!row.nombrePro?.text && !row.horasCarg) ||
          !row.tipoConcepto?.text ||
          !row.comapaniesSelect?.length
        ) {
          descripcionError = t(
            "Los campos obligatorios (*) no pueden ser vacíos",
          );
        } else {
          if (!nombreActValido && (!row.nombrePro || !row.nombrePro.text)) {
            descripcionError = t(
              "Los campos obligatorios (*) no pueden ser vacíos",
            );
          } else if (!nombreActValido) {
            descripcionError = t(
              "El nombre de la actividad no puede ser vacío.",
            );
          } else if (row.nombreAct?.length <= 3) {
            descripcionError = t("El nombre es muy corto.");
          } else if (!row.nombrePro.text) {
            descripcionError = t("Nombre de proyecto vacío.");
          } else if (
            !row.listaProyectos.find((item) => item.key === row.nombrePro.key)
          ) {
            descripcionError = t("El proyecto seleccionado no existe.");
          } else if (
            !row.comapaniesSelect?.every((selected) =>
              listCompanies.some((company) => company.key === selected.key),
            )
          ) {
            descripcionError = t("Una empresa seleccionada no existe.");
          }

          if (!row.horasCarg) {
            descripcionError = t("Horas está vacío.");
          } else if (
            !isValidHoursMinutes(horaParte) ||
            !isValidHoursMinutes(minutoParte)
          ) {
            descripcionError = t("Carácter numérico invalido");
          } else if (valorMin === 0) {
            if (!row.nombreAct || row.nombreAct === "") {
              descripcionError = t(
                "Los campos obligatorios (*) no pueden ser vacíos",
              );
            } else if (valorMin === 0 && !row.nombrePro.text) {
              descripcionError = t(
                "Los campos obligatorios (*) no pueden ser vacíos",
              );
            } else {
              descripcionError = t("Hora no valida");
            }
          } else if (
            !regex.test(row.horasCarg) &&
            !segundoRegex.test(row.horasCarg) &&
            regexUndefine.test(row.horasCarg)
          ) {
            descripcionError = t("Horas solo admite números.");
          }
        }
      }

      const valida = descripcionError ? 0 : 1;

      if (importedPrefix) {
        descripcionError = descripcionError ? `${importedPrefix} ${descripcionError}` :importedPrefix;
      }

      return { ...row, descripcionError, valida };
    };

    const validateRowById = (rows: IAddRows[], id: string) => {
      const updatedRows = rows.map(row => row.id === id ? validateRow(row,row.id) : row);
      setAddRows(updatedRows);
      saveOnSessionStorageDataFormulario(updatedRows);
      HandlerNumError(updatedRows);
    };

    const HandlerAddRows = () => {
      const newdata: IAddRows = {
        id: uuidv4(),
        act_refer_outlook: null,
        act_uid: null,
        end: null,
        start: null,
        nombrePro: { key: "", text: "" },
        nombreAct: "",
        horasCarg: "",
        file: "",
        valida: 2,
        descripcionError: t("nueva fila"),
        actividadRecurrente:"si",
        lisActRecurrente:[],
        actividadRecurrenteSelect:actividadRecurrentenbasic,
        comapaniesSelect: [],
        tipoConcepto:{key:"",text:"",codigo:""},
        listaProyectos:[],
        filterListProyectos:[],
        descripcion:"",
        nombreEmp:{ key: "", text: "" },
        options:0,
        files: []
      };
      const updatedRows = [...addRows, newdata];
      setAddRows(updatedRows);
      HandlerNumError(updatedRows);
    };

    const HandlercleanEverything = ()=>{
      setAddRows([]);
      setDesabled(true);
      setLoading(false);
      saveOnSessionStorageDataFormulario([]);
    }

    const HandlerDeleteRows = (id:string)=>{
      const result = addRows.filter(r=>r.id !== id);
      setAddRows(result);
      HandlerNumError(result);
      // saveOnSessionStorageDataFormulario(result);
      // files id compuesto
      setListFile(prev => prev.filter(item => !item.id.startsWith(id + '@'))); // Ejemplo de id compuesto: "id@uuid"

    }

    const HandlerNombreAct = (id: string, newValue: string | undefined,option:IActivityRecurring) => {
      const valuess = newValue || "";
      const updatedRows = addRows.map(r => r.id === id ? { ...r, nombreAct: valuess,actividadRecurrenteSelect:option } : r);
      validateRowById(updatedRows,id);
    };

    const HandlerNombreActNuevo = (id:string,text:string)=>{
      const updatedRows = addRows.map(r => r.id === id ? { ...r, nombreAct:text} : r);
        validateRowById(updatedRows, id);
    }

    const HandlerContHoras = (id: string, newValue: string | undefined, type: 'hour' | 'minute') => {
      const updatedRows = addRows.map(row => {
        if (row.id === id) {
          const [currentHour, currentMinute] = (row.horasCarg || "00:00").split(':');
          const newHour = type === 'hour' ? newValue || '' : currentHour;
          const newMinute = type === 'minute' ? newValue || '' : currentMinute;
          return { ...row, horasCarg: `${newHour}:${newMinute}` };
        }
        return row;
      });
      validateRowById(updatedRows, id);
    };

    const onselectProject = async (option: IComboBoxInput | undefined, id: string, inputText: string | undefined) => {
      const updatedRows = addRows.map((r) =>
        r.id === id
          ? {
              ...r,
              nombrePro: option || { key: '', text: inputText || '' },
              //nombreAct:"",
              pro_inicio: option?.pro_inicio,
              pro_fin: option?.pro_fin,
            }
          : r,
      );
      validateRowById(updatedRows, id);
      setLoading(true);
      const getListActvityRecurring = await props.system.getLisActivityRecurring(String(option?.key), id);
      if (getListActvityRecurring) {
        const updatedRowss = updatedRows.map((r) => (r.id === id ? { ...r, lisActRecurrente: getListActvityRecurring } : r));
        validateRowById(updatedRowss, id);
      }
      setLoading(false);
    };

    const ProjectFilterChange = (text: string, id: string, listaProyect: IComboBoxOption[]) => {
      const updatedRows = addRows.map((r) =>
        r.id === id
          ? {
              ...r,
              nombrePro: { ...r.nombrePro, text: text || '' },
              filterListProyectos: listaProyect.filter((g) => g.text.toLowerCase().includes(text.toLowerCase())),
            }
          : r,
      );
      validateRowById(updatedRows, id);
    };

    const onselecTipoConcept = async (option: ItipoConcepto | undefined, id: string) => {
      const updatedRows = addRows.map((r) =>
        r.id === id
          ? {
              ...r,
              tipoConcepto: option || { key: '', text: '', codigo: '' },
              nombrePro: { key: '', text: '' },
              // listaProyectos: [],
              //filterListProyectos: [],
              // nombreAct: '',
              // actividadRecurrente: '',
              // actividadRecurrenteSelect: undefined,
              // lisActRecurrente: [],
            }
          : r,
      );
      validateRowById(updatedRows, id);
      if (option) {
        const exercise_period = formatDate(periodo);
        setLoading(true);
        const data = await fetchProjects(collaboratorId, exercise_period, option?.key);
        if (data) {
          const listProyectFiltrado = updatedRows.map((r) => (r.id === id ? { ...r, listaProyectos: data, filterListProyectos: data } : r));
          validateRowById(listProyectFiltrado, id);
        }
        setLoading(false);
      }
    };

    const onselectCompany = async(options: IComboBoxOption[], id: string) => {
      const updatedRows = addRows.map((r) =>
        r.id === id
          ? {
              ...r,
              nombreEmp: { key: options[0]?.key || "", text: options[0]?.text || "" },
              comapaniesSelect: options,
              tipoConcepto: { key: "", text: "", codigo:"" },
              nombrePro: { key: "", text: "" },
              listaProyectos: [],
              filterListProyectos: [],
              actividadRecurrenteSelect: undefined,
              lisActRecurrente: [],
            }
          : r
      );
      validateRowById(updatedRows, id);
    };

    const companyFilterChange = (text: string) => {
      const data = listCompanies.filter(g => g.text.toLowerCase().includes(text.toLowerCase()));
      setFilterListCompanies(data);
    };

    const tipoConceptFilterChange = (text: string, id: string) => {
      const updatedRows = addRows.map(r => r.id === id ? { ...r, tipoConcepto: { ...r.tipoConcepto, text: text || "" } } : r);
      const data = listtipoConcept.filter(g => g.text.toLowerCase().includes(text.toLowerCase()));
      setFilterTipoConsept(data);
      validateRowById(updatedRows, id);
    };

    const handlerDescripcion = (data: string | undefined, id:string) => {
      const updatedRows = addRows.map(r => r.id === id? { ...r, descripcion:data || ""}:r);
      validateRowById(updatedRows,id);
    }

    const HandlerPeriodo = async (date:Date)=>{
      props.changeBlockUI(true);
      cleanActiveProject()
      setPeriod(date);
      const exercise_period = formatDate(date);
      await getHorasTal(collaboratorId,exercise_period);
      props.changeBlockUI(false);
    }

    const cleanActiveProject = ()=>{
     setAddRows([]);
     setDesabled(true);
     HandlerNumError([]);
    }

    const cleanActiveProjectsLaterSave = () => {
      setAddRows([]);
      setDesabled(true);
      HandlerNumError([]);
    }

    const formatPeriodToYYYYMMDD = (datePeriod: Date) => {
      const fecha = datePeriod instanceof Date ? datePeriod : new Date(datePeriod);
      return fecha.toISOString().split("T")[0];
    }

    const saveFile = async (actIdByRowId: Map<string, string>) => {
      const idFile = await props.system.documentTypeOtherId();

      for (const item of listFile) {
        const rowId = item.id.split('@')[0];
        const actId = actIdByRowId.get(rowId);
        if (!actId) {
          console.error(`No se encontró actividad guardada para el archivo de la fila ${rowId}`);
          continue;
        }

        const filePayload: Ifileselect = {
          cmd_actid: actId,
          cmd_cant_archivos: 1,
          cmd_cant_bytes_total: item.path.size,
          cmd_tipo: uploadTypeActivity,
          cargaDocumentosItems: [
            {
              cmdi_cant_bytes: item.path.size,
              cmdi_doc_uuid: "0",
              cmdi_nombre_archivo: item.path.name,
              cmdi_content_type: item.path.type,
              doctId: idFile,
              tipo: uploadItemActivityType,
              actId,
            }
          ]
        };

        try {
           await props.system.getActivitySystem().UploadfileForm(filePayload, item.path, formatPeriodToYYYYMMDD(periodo));
        } catch (error) {
          console.error('Error uploading file:', error);
        }
      }
    };


    const handleMultipleFiles = async (fileList: File[], rowId: string) => {
      const newFileEntries: IListFile[] = fileList.map((file) => ({
        path: file,
        // Agregar un id compusto para despues poder eliminarlo si eliminan las fila
        id: `${rowId}@${uuidv4()}`,
      }));

      // Agregar o reemplazar archivos para esa fila
      setListFile(prev => {
        return [...prev, ...newFileEntries]
      });

      // Guardar también en la fila
      setAddRows(prev =>
        prev.map(row =>
          row.id === rowId
            ? { ...row, files: [...(row.files || []), ...fileList] }
            : row
        )
      );
    };

    const handleFileDelete = (index: number, rowId: string) => {
      setAddRows(prev =>
        prev.map(row =>
          row.id === rowId
            ? { ...row, files: row.files.filter((_, i) => i !== index) }
            : row
        )
      );

      setListFile(prev =>
        prev.filter((item, i) => {
          const isSameRow = item.id.startsWith(rowId + '@'); // Verifica si el id comienza con rowId
          const indexInRow = prev.filter(f => f.id.startsWith(rowId + '@')).indexOf(item);
          return !isSameRow || indexInRow !== index;
        })
      );
    };

    const getDataLocalStorage = () => {
      const recoveredData = getSessionStorageDataFormulario() || [];
      setShowRecoveredDataDialog(recoveredData?.length > 0 ? true : false);
    }

    const HandlerNumError = (validados: IAddRows[]) => {
      const actVali = validados.filter((g) => g.valida === 1);
      const actvErro = validados.filter((g) => g.valida === 0);
      const existDescriptionError = validados.some(
        (g) => g.descripcionError !== "nueva fila" &&
               g.descripcionError !== "actividades recurrentes" &&
               g.descripcionError !== "" &&
               !g.descripcionError?.startsWith(IMPORTED_ROW_PREFIX)
      );

      setActError({ actVali: actVali.length, actvErro: actvErro.length });

      if (
        actvErro.length === 0 &&
        actVali.length > 0 &&
        !existDescriptionError
      ) {
        setDesabled(false);
      } else {
        setDesabled(true);
      }
    };

    const onsubmit = async (ev: FormEvent<HTMLFormElement>) => {
      ev.preventDefault();

      // Calcular el total de horas que se intenta registrar en el mes
      const totalHorasCargadas = addRows.reduce((acc, row) => acc + convertHourToMin(row.horasCarg), 0);

      // Validar si excede el límite de horas
      if (totalHorasCargadas > horasTotalCollaborator) {
        setShowHoursDialog(true);
        return;
      }

      // Si no se supera el límite de horas, proceder con la carga
      handleConfirmHoursDialog();
      saveOnSessionStorageDataFormulario([]);
    }

    const handleConfirmHoursDialog = async () => {
      props.courier.messageWarning('')
      setShowHoursDialog(false);
      props.changeBlockUI(true);

        if(addRows){
          const filteredRows = addRows.filter((row) => row.valida === 1);
          const tranForm = filteredRows.map(row =>{
              const numer = convertHourToMin(row.horasCarg as any);
              return {
                impai_nombre: row.nombreAct,
                impai_cantidad_horas : convertMinToHour(numer),
                impai_codigo_proyecto: row.nombrePro.code,
                impai_proid: row.nombrePro.key,
                impai_con_error: false,
                impai_descripcion_error: row.descripcionError,
                impai_descripcion: row.descripcion,
                impai_codigo_empresa: row.nombreEmp.key,
                impai_empresas: row.comapaniesSelect?.map((comp) => comp.key) || [],
                act_uid: row.act_uid,
                act_refer_outlook: row.act_refer_outlook
              }
          });

          const body:IactivitiesBody = {
            activities:tranForm,
            col_id: collaboratorId,
            exercise_period:DateCustom.formatDateYYYYMM(periodo),
            timezone: "America/Lima"
          };
          setDesabled(true)
          const numProjetct = filteredRows.length;
          try {
            const importForm = await props.system.getActivitySystem().saveActivity(headers,body);

            const actIdByRowId = new Map<string, string>();
            filteredRows.forEach((row, i) => {
              const actId = importForm.data?.[i]?.act_id;
              if (actId) actIdByRowId.set(row.id, actId);
            });

            await saveFile(actIdByRowId);
            cleanActiveProjectsLaterSave();
            postPlantillaActividadesXColaborador();
            getHorasTal(collaboratorId,DateCustom.formatDateYYYYMM(periodo));
            const message =
              numProjetct === 1
                ? "Se cargó {{count}} fila de manera exitosa"
                : "Se cargaron {{count}} filas de manera exitosa";

            props.courier.messageSuccess(t(message, { count: numProjetct }));

            if (importForm.error) {
              props.courier.messageError(importForm.error);
            }

            setListFile([]);
          } catch (error) {
            console.log(error);
            const apiErrorMessage = error instanceof XhrRequestError ? error.getApiErrorMessage() : '';
            props.courier.messageError(apiErrorMessage || t('Ocurrió un error al importar las actividades. Por favor, intenta nuevamente o contacta al administrador.'));
          }
        }
      props.changeBlockUI(false);
    };

    const handleCancelHoursDialog = () => {
      setShowHoursDialog(false);
    };

    const handleConfirmRecoveredDataDialog = async() => {
      props.courier.messageWarning('')
      setShowRecoveredDataDialog(false);
      props.changeBlockUI(true);

      // Se excluyen las actividades importadas desde la agenda
      const recoveredData = getSessionStorageDataFormulario().filter((r) => !r.descripcionError?.startsWith(IMPORTED_ROW_PREFIX));

      if (recoveredData.length > 0) {
        const updatedRows = recoveredData.map((item: any) => {
          const newData = { ...item, id: uuidv4(), options: 0 };
          return validateRow(newData, newData.id);
        });

        setAddRows(updatedRows);
        HandlerNumError(updatedRows);
      }
      props.changeBlockUI(false);
    }

    const handleCancelRecoveredDataDialog = () => {
      setShowRecoveredDataDialog(false);
    };

    const postPlantillaActividadesXColaborador = async () => {
      const filteredRows = addRows.filter((row) => row.valida === 1 && isNull(row.act_refer_outlook) && isNull(row.act_uid));
      console.log("val-filteredRows", filteredRows);

      const parceData:IPosplantillaActividadesColaborador[] = await Promise.all(filteredRows.map( async row =>{
        console.log("val-parceData", row.nombreEmp.key);

        let ar_id:string = row.actividadRecurrenteSelect?.ar_id ||"";
            if(ar_id === ""){
              const recuperation ={
                codigoConcepto:parseInt(row.tipoConcepto.key as string) ,
                codigoProyecto:parseInt(row.nombrePro.key as string),
                nombreActividad:row.nombreAct,
                codigoEmpresa:parseInt(row.nombreEmp.key as string),
                codigoPais:1
              }
              const {ar_id_data} = await props.system.postAddRecurrentActivity(recuperation,headers.idTransaccion);
              ar_id=ar_id_data;
            }

        return {
          paxc_col_id: collaboratorId,
          paxc_data: {
            ar_id: ar_id,
            proy_id: row.nombrePro.key,
            recurrent: row.actividadRecurrente,
            tc_id: row.tipoConcepto.key,
            ar_empresa_id: row.nombreEmp.key,
            ar_empresa_select: (row.comapaniesSelect || []).map((company) => ({
              value: String(company.key),
              label: company.text,
            })),
            ar_descripcion: row.descripcion,
          },
        };
      })) as any  ;

        await props.system.postPlantillaActividadesXColaborador( parceData,headers.idTransaccion);

    };

    const getHorasTal = async (col_id:string,exercise_period:string)=>{
      setDesableAddRow(true)

      const firstDay = DateTime.fromFormat(exercise_period, 'yyyy-MM').startOf('month');
      const lastDay = DateTime.fromFormat(exercise_period, 'yyyy-MM').endOf('month');

      const dataHours = await props.system.getPanelSystem().getMyPlanProjectData(firstDay, lastDay, col_id);
      const statusHours = dataHours.estadoHoras[0]["horas"];
      const pending_minutes = statusHours.horasFaltantes ? statusHours.horasFaltantes * 60 : statusHours.horasExcedidas * -60;

      if (dataHours && dataHours.estadoHoras && dataHours.estadoHoras.length > 0) {
        setHorasTotalCollaborator(pending_minutes);
        setDesableAddRow(() => false);
      }
    };

    const getListActivityRecurring = async(collaboratorId:string)=>{
      setLoading(true);
      const uuidTransaccion=uuidv4();
      const exercise_period = formatDate(periodo);
      const data = await props.system.getAllProjectsByCollaboratorCargarFormulario(collaboratorId,exercise_period);
      const projectsList =  data.map(v=>({ key:v.getId(),text:v.getName(), code:v.getCode() }));
      const projectValided = projectsList.map(item=>item?.key);

        if(projectValided.length !== 0){
          const activity:IPlantillaActividadesXColaborador[] = await props.system.getPlantillaActividadesXColaborador(collaboratorId,headers.idTransaccion,projectValided);
          if(activity.length === 0) {
            HandlerAddRows();
          }else{
                const listActivity:IAddRows[] = await Promise.all (activity.map( async item =>{
                const getListActvityRecurring = await props.system.getLisActivityRecurring(String(item.paxc_data.proy_id),uuidTransaccion);
                const exercise_period = formatDate(periodo);
                const data = await fetchProjects(collaboratorId,exercise_period,item.paxc_data.tipoConcepto.tc_id);

                console.log("val-item.paxc_data.ar_empresa_select", item.paxc_data.ar_empresa_select);


                const empresaSelect: IComboBoxOption[] = (item.paxc_data.ar_empresa_select || []).map((emp: any) => ({
                  key: emp.value,
                  text: emp.label,
                }));

                const newdata: IAddRows = {
                id: uuidv4(),
                act_refer_outlook: null,
                act_uid: null,
                end: null,
                start: null,
                nombrePro: { key: item.paxc_data.proy_id, text:item.paxc_data.pro_nombre },
                nombreAct: item.paxc_data.ar_nombre_act,
                horasCarg: "",
                file: "",
                valida: 2,
                descripcionError: t("actividades recurrentes"),
                actividadRecurrente:item.paxc_data.recurrent,
                lisActRecurrente:getListActvityRecurring,
                actividadRecurrenteSelect:{...actividadRecurrentenbasic,ar_id:item.paxc_data.ar_id},
                tipoConcepto:{key:item.paxc_data.tipoConcepto.tc_id,
                              text:item.paxc_data.tipoConcepto.tc_nombre,codigo:item.paxc_data.tipoConcepto.tc_codigo},
                listaProyectos:data || [],
                filterListProyectos:data || [],
                descripcion: item.paxc_data.ar_descripcion ||"",
                comapaniesSelect: empresaSelect,
                nombreEmp: empresaSelect[0] || { key: "", text: "" },
                options:0,
                files: []
              };
                return newdata;
              }))
              setAddRows(listActivity);
              // saveOnSessionStorageDataFormulario(listActivity);
          }
        }
        setLoading(false);
    }

    const buildHourFromParts = (hora: any, minuto: any) => {
      const stripQuotes = (value: any) =>
        (value ?? "").toString().replace(/^="?/, "").replace(/"$/, "").trim();
      const horaLimpia = stripQuotes(hora) || "0";
      const minutoLimpio = stripQuotes(minuto) || "0";
      return `${horaLimpia}:${minutoLimpio.padStart(2, "0")}`;
    };

    const HandlerDataToExcel = () => {
      const dataExcel: any[][] = [];
      const zeroWidthSpace = '\u200B';

      addRows.forEach((row: IAddRows) => {
        const [horas, minutos] = (row.horasCarg || "00:00").split(":");
        dataExcel.push([
          row.comapaniesSelect?.map((comp) => comp.text).join(", ") || "",
          row.tipoConcepto.text,
          row.nombrePro.text.toString(),
          `${zeroWidthSpace}${row.nombreAct?.toString()}`,
          `${zeroWidthSpace}${row.descripcion?.toString()}`,
          horas || "00",
          minutos || "00"
        ]);
      });

      return dataExcel;
    };

    const HandlerDataFromExcel = async (data: any[][]) => {
      setAddRows([]);

      console.log("val-data", data);


      const filteredData = data.filter((row) =>
        row.some((cell) => String(cell ?? "").trim() !== "")
      );

      for (const row of filteredData) {
        setLoading(true);
        let datatipoConcepto = listtipoConcept.filter((g) =>
          normalizeText(g.text).includes(normalizeText(row[1]))
        );

        const companyNames = String(row[0] || "").split(",").map((name) => normalizeText(name.trim())).filter(Boolean);
        const filterDataCompany = listCompanies.filter((g) => companyNames.includes(normalizeText(g.text)));

        const exercise_period = formatDate(periodo);
        const dataProject = await fetchProjects(
          collaboratorId,
          exercise_period,
          datatipoConcepto[2]?.key
        );
        const datanombrePro = dataProject?.find(
          (g) =>
            row[2].trim() !== "" &&
            normalizeText(g.text) === normalizeText(row[2])
        );

        if (datanombrePro && datatipoConcepto.length > 0) {
          // Validar si el proyecto corresponde al tipo de concepto porque el usuario puede haber ingresado un proyecto que no corresponde al tipo de concepto seleccionado
          const tipoConceptoValido = datanombrePro.code.startsWith(datatipoConcepto[0].codigo, 0); // Example: "PROFA2025-30" -> "PRO"
          if (!tipoConceptoValido) {
           datatipoConcepto = [];
          }
        }

        const newdata: IAddRows = {
          id: uuidv4(),
          act_refer_outlook: null,
          act_uid: null,
          end: null,
          start: null,
          nombrePro: {
            key: datanombrePro?.key || "",
            text: datanombrePro?.text || "",
            code: datanombrePro?.code || "",
          },
          nombreAct: row[3] || "",
          horasCarg: buildHourFromParts(row[5], row[6]),
          file: "",
          valida: 2,
          descripcionError: t("nueva fila"),
          actividadRecurrente: "si",
          lisActRecurrente: [],
          actividadRecurrenteSelect: actividadRecurrentenbasic,
          tipoConcepto: datatipoConcepto[0],
          listaProyectos: dataProject || [],
          filterListProyectos: dataProject || [],
          descripcion: row[4]?.trim() || "",
          comapaniesSelect: filterDataCompany,
          nombreEmp: filterDataCompany[0] || { key: "", text: "" },
          options:0,
          files: []
        };

        setAddRows((prevRows) => [...prevRows, newdata]);
        const getListActvityRecurring = datanombrePro?.key ? await props.system.getLisActivityRecurring(
            String(datanombrePro?.key),
            newdata.id
          ) : []

        setAddRows((prevRows) =>
          prevRows.map((r) =>
            r.id === newdata.id
              ? {
                  ...r,
                  nombreAct: row[3] ? row[3].trim() : "",
                  lisActRecurrente: getListActvityRecurring,
                }
              : r
          )
        );

        setAddRows((prevRows) =>
          prevRows.map((r) =>
            r.id === newdata.id ? validateRow(r, newdata.id) : r
          )
        );
      }
      setAddRows(prevRows => {
        HandlerNumError(prevRows);
        return prevRows; // Mantener el estado
      });
      setLoading(false);
    };

    const handlerDuplicateRow = (data: any) => {
      const newData = { ...data, id: uuidv4(), options:0};
      const updatedRows = [...addRows, newData];
      setAddRows(updatedRows);
      HandlerNumError(updatedRows);
    }

    const onClickCallout = (id: string) => {
      const updatedRows = addRows.map(r => r.id === id ? { ...r, options: r.options === 0 ? 1 : 0 }: r);
      validateRowById(updatedRows, id);
    }

    const toggleTooltip = () => {
      if (isMobile) {
        setTooltipVisible(!tooltipVisible);
      }
    };

    useEffect(() => {
      if(collaboratorId ){
        const fetchData = async () => {
          try {
            await getListActivityRecurring(collaboratorId);
            await getCompaniesAndProjects(periodo);
            getDataLocalStorage();
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };
        fetchData();
        setLoading(false);
      }
    },[periodo,collaboratorId]);

    useEffect(() => {
      getListWorkingDay(props.user.getColEmppId(), periodo.getFullYear().toString());
    }, [periodo, collaboratorId]);

    useEffect(()=>{
      getLisTipoConcept();
      getAllPeriodBlocks();
      if(props.user){
        handleSelectCollaborator({key:props.user.getCollaboratorId(),text:props.user.getCollaborator().getName() +" "+ props.user.getCollaborator().getLastName()});
      }
      fetchCollaborators()
    },[]);

    const loadExternalEventsInBackground = async () => {
      const start = new Date(periodo.getFullYear(), periodo.getMonth(), 1);
      const end = new Date(periodo.getFullYear(), periodo.getMonth() + 1, 0, 23, 59, 59, 999);

      const events: EventOutlook[] = [];
      const filters: CalendarFilters = getDefaultFilters();

      let numberPage = 1;

      props.changeBlockUI(true);
      setIsLoadingEventsFromOutlook(true);

      try {
        const calendar = new Calendar(props.system.getActivitySystem());

        const _events = await calendar.getEvents(
            start,
            end,
            props.user.getCollaboratorId(),
            filters
        );

        while (true) {
          const res = await calendar.getExternalEventsData(
            start,
            end,
            _events,
            filters,
            numberPage
          );

          events.push(...res.events);

          if (!res.pages) {
            break;
          }

          numberPage++;
        }

        if (events.length === 0 ) {
          return props.courier.messageError(t("No se encontraron eventos en la agenda corporativa para el período seleccionado."))
        }

        importOutlookEvents(events);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoadingEventsFromOutlook(false);
        props.changeBlockUI(false);
      }
    };

    const importOutlookEvents = (events: EventOutlook[]) => {

      setAddRows((prev) => {
        const rows: IAddRows[] = events.map((event) => {
          const start = DateCustom.ParseDateFromApiStr(event.start);
          const end = DateCustom.ParseDateFromApiStr(event.end);
          const totalMinutes = Math.floor((end.getTime() - start.getTime()) / 60000);
          const hours = Math.floor(totalMinutes / 60);
          const minutes = totalMinutes % 60;
          const startFormatted = formatDateTimeYYMMDDDDHHMM(start);

          return {
            id: event.uid,
            act_uid: event.iCalUID,
            act_refer_outlook: event.id,
            end: event.end,
            start: event.start,
            nombrePro: { key: "", text: "" },
            nombreAct: event.subject ?? "",
            horasCarg: `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`,
            minuteCarg: minutes.toString().padStart(2, "0"),
            file: "",
            valida: 2,
            descripcionError: `${IMPORTED_ROW_PREFIX} ${startFormatted}. Faltan campos obligatorio`,
            actividadRecurrente: "no",
            lisActRecurrente: [],
            actividadRecurrenteSelect: actividadRecurrentenbasic,
            comapaniesSelect: [],
            tipoConcepto: { key: "", text: "", codigo: "" },
            listaProyectos: [],
            listaEmpresa: [],
            filterListProyectos: [],
            descripcion: "",
            paisEmpresa: { key: "", text: "" },
            nombreEmp: { key: "", text: "" },
            options: 0,
            files: [],
          };
        });

        // Evitar que se inserten eventos duplicados
        const existingUids = new Set(prev.map((r) => r.id).filter((uid) => !!uid));
        const newRows = rows.filter((row) => !existingUids.has(row.id!));
        return [...prev, ...newRows];
      });
    };

    if (!props.loading) {
      return <Loading title='Cargando' description='Por favor espere estamos procesando la información necesaria para completar su solicitud.'/>
    }

    console.log("val-addRow", addRows);

    return (
      <form
        className="ms-Grid"
        dir="ltr"
        style={{
          minHeight: "100%",
          fontFamily:
            'Segoe UI, "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
        }}
        onSubmit={onsubmit}
      >
        <FormUploadHeader />
        <Custoneader
          mountBlock={mountBlock}
          filteredCollaborators={filteredCollaborators}
          collaboratorValue={collaboratorValue}
          handleSelectCollaborator={handleSelectCollaborator}
          handleFilterCollaborator={handleFilterCollaborator}
          periodo={periodo}
          HandlerPeriodo={HandlerPeriodo}
          horasTotal={horasTotal}
          addrowlength={addRows.length}
          convertMinToHour={convertMinToHour}
          desabled={desabled}
          UploadIcon={UploadIcon}
          actError={actError}
          tipoConcept={listtipoConcept}
          desableAddRow={desableAddRow}
          HandlerAddRows={HandlerAddRows}
          AddIcon={AddIcon}
          dataUser={props.user}
          HandlercleanEverything={HandlercleanEverything}
          HandlerCopyToClipboard={HandlerDataToExcel}
          HandlerDataFromExcel={HandlerDataFromExcel}
          courier={props.courier}
          handleLoadEvents={loadExternalEventsInBackground}
          loadingEvents={isLoadingEventsFromOutlook}
        />
        <br />
        <br />
        <div>
          <div>
            <div>
              <hr />
              <div style={{ position: "relative", maxWidth: 1420, margin: '0 auto' }}>
                {loading && <LoadingPage />}
                {addRows.map((row) => (
                  <ActivityRow
                    key={row.id}
                    row={row}
                    aiActivityEnhancementSystem={aiActivityEnhancementSystem}
                    isMobile={isMobile}
                    listCompanies={listCompanies}
                    filterListCompanies={filterListCompanies}
                    companyFilterChange={companyFilterChange}
                    HandlerContHoras={HandlerContHoras}
                    HandlerDeleteRows={HandlerDeleteRows }
                    HandlerNombreAct={HandlerNombreAct}
                    HandlerNombreActNuevo={HandlerNombreActNuevo}
                    ProjectFilterChange={ProjectFilterChange}
                    filterTipoConsept={filterTipoConsept}
                    handlerDescripcion={handlerDescripcion}
                    handlerDuplicateRow={handlerDuplicateRow}
                    onClickCallout={onClickCallout}
                    onselecTipoConcept={onselecTipoConcept}
                    onselectCompany={onselectCompany}
                    onselectProject={onselectProject}
                    setTooltipVisible={setTooltipVisible}
                    tipoConceptFilterChange={tipoConceptFilterChange}
                    toggleTooltip={toggleTooltip}
                    updateActivityNameAndDescription={updateActivityNameAndDescription}
                    handleMultipleFiles={handleMultipleFiles}
                    handleFileDelete={handleFileDelete}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

      <HoursLimitDialog
        isOpen={showHoursDialog}
        horasExcedidas={horasExcedidas}
        onConfirm={handleConfirmHoursDialog}
        onCancel={handleCancelHoursDialog}
      />

      <DialogRecoveredData
        isOpen={showRecoveredDataDialog}
        onConfirm={handleConfirmRecoveredDataDialog}
        onCancel={handleCancelRecoveredDataDialog}
      />
      </form>
    );
}

export default CargarPorFormulario
